module.exports = __webpack_public_path__ + "html/subscription_b19e36422bfd5919c31a5643d5642656.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription.html
// module id = py5d
// module chunks = 3 8